function capitalizeString(str: string) {
  const lowerStr = str.toLowerCase();
  return lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1);
}

function getRobotDisplayName(name: string) {
  const numIdx = name.search(/\d/);
  const robotName = name.substring(0, numIdx);
  const robotNum = name.substring(numIdx);
  return `${capitalizeString(robotName)} ${robotNum}`;
}

export { capitalizeString, getRobotDisplayName };
